import { useRef } from "react";
import genId from "../utils/genId";

const useId = (prefix = "") => {
  return useRef(genId(prefix)).current;
};

export default useId;
